var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.163438 3.56596C-0.0544794 3.81577 -0.0544794 4.19048 0.163438 4.4153L3.45642 7.81265C3.69855 8.06245 4.06174 8.06245 4.27966 7.81265L4.83656 7.26308C5.05448 7.01327 5.05448 6.63856 4.83656 6.41374L2.48789 3.99063L4.83656 1.59251C5.05448 1.36768 5.05448 0.967994 4.83656 0.743169L4.27966 0.168618C4.06174 -0.0562061 3.69855 -0.0562061 3.45642 0.168618L0.163438 3.56596Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f08c4181ada42996ee0daf4e221778cc.svg";
export { ForwardRef as ReactComponent };